import React, { type ReactNode } from 'react';

import { ModalBody, ModalFooter, ModalHeader, ModalTitle } from '@atlaskit/modal-dialog';
import { Stack, Text } from '@atlaskit/primitives/compiled';
import Spinner from '@atlaskit/spinner';

export const Loading = ({
	loadingText,
	title,
}: {
	loadingText?: ReactNode;
	title: ReactNode;
}): React.JSX.Element => (
	<>
		<ModalHeader hasCloseButton>{title ? <ModalTitle>{title}</ModalTitle> : null}</ModalHeader>
		<ModalBody>
			<Stack space="space.400" alignInline="center">
				{/* Doesn't need a label because the text below it is present. No label === presentational */}
				<Spinner size="large" label="" />
				<Text color="color.text.subtle">{loadingText ?? 'Loading dialog content...'}</Text>
			</Stack>
		</ModalBody>
		<ModalFooter />
	</>
);
